import React, {FC} from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography,} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import useExtensions from "@/hooks/useExtensions";
import { RichTextReadOnly } from "mui-tiptap";

interface FaqProps {
  title?: string;
  description?: string;
  tab: number | string;
}

const Faq: FC<FaqProps> = ({ title, description, tab }) => {
  const [expanded, setExpanded] = React.useState<string | number | false>(
    false
  );
  const extensions = useExtensions();
  const handleChange =
    (panel: string | number) =>
    (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Accordion
      expanded={expanded === tab}
      onChange={handleChange(tab)}
      sx={{
        px: 3,
        py: 2,
        backgroundColor: "var(--ghost-white)",
        borderRadius: "8px",
        boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.15) !important",
        "&:before": {
          display: "none",
        },
        "& .Mui-expanded": {
          minHeight: "48px !important",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiAccordionSummary-content": {
          margin: 0,
        },
        "& .MuiAccordionSummary-expandIconWrapper": {
          padding: "6px",
          color: "var(--cimigo-blue)",
        },
      }}
      slotProps={{ transition: { unmountOnExit: true } }}
    >
      <AccordionSummary
        expandIcon={expanded ? <RemoveIcon /> : <AddIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        sx={{ px: 0 }}
      >
        <Typography
          component="span"
          sx={{
            flex: 1,
            fontWeight: 600,
            fontSize: { xs: "16px", sm: "18px" },
            lineHeight: "24px",
            color: "var(--cimigo-blue)",
            fontFamily: "Montserrat",
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>
        <Box
          sx={{
            fontFamily: "Montserrat",
            fontWeight: 400,
            fontSize: { xs: "14px", sm: "16px" },
            lineHeight: "24px",
            width: "fit-content",

            "& p": {
              margin: 0,
              color: "var(--eerie-black)",
            },
          }}
        >

        <div className="custom-rich-text">
          <RichTextReadOnly
            injectCSS={true}
            content={description ?? ""}
            extensions={extensions}
          />
        </div>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default Faq;
